import React from 'react';
import campaignsIcon from '../../../assets/area-icons/campaigns.png';
import dashboardsIcon from '../../../assets/area-icons/dashboards.png';
import docsIcon from '../../../assets/area-icons/docs.png';

/**
 * Peer switcher: Dashboards | Campaigns | Documents.
 * List actions (new / collapse-all) live on the campaign list, not this tab.
 */
const SidebarAreaSwitcher = ({
  area = 'workspace',
  onChange,
}) => {
  const active =
    area === 'docs' ? 'docs' : area === 'dashboards' ? 'dashboards' : 'workspace';

  return (
    <div
      className="sidebar__area-switcher"
      data-area={active}
      role="tablist"
      aria-label="Content area"
    >
      <button
        type="button"
        role="tab"
        aria-selected={active === 'dashboards'}
        className={`sidebar__area-tab ${active === 'dashboards' ? 'sidebar__area-tab--active' : ''}`}
        onClick={() => onChange?.('dashboards')}
        title="Dashboards"
      >
        <img
          className="sidebar__area-icon"
          src={dashboardsIcon}
          alt=""
          draggable={false}
        />
        <span>Dashboards</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === 'workspace'}
        className={`sidebar__area-tab ${active === 'workspace' ? 'sidebar__area-tab--active' : ''}`}
        onClick={() => onChange?.('workspace')}
        title="Campaigns & missions"
      >
        <img
          className="sidebar__area-icon"
          src={campaignsIcon}
          alt=""
          draggable={false}
        />
        <span>Campaigns</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === 'docs'}
        className={`sidebar__area-tab ${active === 'docs' ? 'sidebar__area-tab--active' : ''}`}
        onClick={() => onChange?.('docs')}
        title="Documents"
      >
        <img
          className="sidebar__area-icon"
          src={docsIcon}
          alt=""
          draggable={false}
        />
        <span>Documents</span>
      </button>
    </div>
  );
};

export default SidebarAreaSwitcher;
